export default __webpack_public_path__ + "static/media/dnnenterprises.c85c0d5e.svg";